import { useGetPickupLocationByIdQuery } from "~/shared/api/pickup-locations/pickup-locations.grpc";
import { useSelectedCompany } from "~/shared/store/company/hooks/useSelectedCompany";

/**
 * The location with its BY_NORM contracts preloaded. One cache entry serves the
 * Participants tab and the attach modal, and the attach / contract mutations
 * invalidate it.
 */
export const useLocationSubscriptions = (locationId?: bigint) => {
  const { selectedCompanyId } = useSelectedCompany();
  const { currentData: pickupLocation, isFetching } = useGetPickupLocationByIdQuery(
    { id: locationId ?? 0n, serviceProviderId: BigInt(selectedCompanyId ?? 0) },
    { skip: !locationId || !selectedCompanyId },
  );

  return {
    pickupLocation,
    subscriptionContracts: pickupLocation?.subscriptionContracts ?? [],
    isFetching,
  };
};
